module.exports = __webpack_public_path__ + "fonts/Raleway-Medium.430a0518.ttf";